import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface UpdatePayload {
  [key: string]: string;
}

export const useUpdateEmailNotificationTemplateQuery = (orgId?: string) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(async (payload: UpdatePayload) =>
    api.patch(API_URL.ORGANIZATIONS_NOTIFICATION_PROPERTIES_BY_ORGANIZATION_ID(orgId || ''), payload)
  );

  return {
    updateEmailNotificationTemplate: mutateAsync,
    isLoading,
    isSuccess,
  };
};
